module.exports = __webpack_public_path__ + "files/8dfe95481ebb1aef61a4cef76dca2cbd.svg";